<template>
	<v-tab-item>
		<h3 class="text-h6 font-weight-bold">案件詳細</h3>
		<MatterInfo v-if="matter" :matter="matter" dialogMode />
	</v-tab-item>
</template>

<script>
import axios from "axios"
import authenticate from "../../../../helper/authenticate"
import errorHandling from "../../../../helper/errorHandling"
import MatterInfo from "../../../shared/MatterInfo.vue"

export default {
	props: {
		id: {
			type: null,
		},
		matter_id: {
			type: null,
			required: true,
			default: () => {},
		},
		isFetched: {
			type: Boolean,
		},
	},
	components: {
		MatterInfo,
	},
	data() {
		return {
			matter: null,
		}
	},
	methods: {
		getMatter() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/matters/" + this.matter_id + ".json", {
					headers,
				})
				.then((response) => {
					this.matter = response.data.matter
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {
		isFetched(newVal, oldVal) {
			if (oldVal == false && newVal == true) {
				this.getMatter()
			} else if (oldVal == true && newVal == false) {
			}
		},
		deep: true,
	},
}
</script>